<template>
    <b-overlay :show="loading" rounded="sm">
        <b-row class="gx-0 mb-2">
            <b-col cols="12" class="dd">
                <label class="mb-3" for="input-assets"><strong>{{ $translate('assets') }}</strong></label>
                <multiselect id="input-assets" :deselectLabel="deselectLabel" :selectedLabel="selectedLabel" :selectLabel="selectLabel" :disabled="disabled" :placeholder="$translate('none_selected')" v-model="selectedAssets"
                    :multiple="true" :close-on-select="false" :options="parseAssets(customerAssets)" label="text" track-by="value">
                </multiselect>
            </b-col>
        </b-row>
    </b-overlay>
</template>

<script>
import EventBus from "@/exports/event-bus.js";
import Multiselect from 'vue-multiselect'
export default {
    name: 'ViewAssets',
    props: ['value', 'customer_id', 'disabled', 'master_item_id'],
    components: { Multiselect },
    data() {
        return {
            loading: false,
            selectedAssets: [],
            customerAssets: [],
            cust_id: this.customer_id,
            is_customer_or_company_asset: null,
        }
    },

    computed: {
        assets() {
            return this.$store.state.assets.assets || [];
        },
        company() {
            return this.$store.state.company.settings;
        },
        selectLabel() {
            return this.$translate('click_to_select')
        },
        deselectLabel() {
            return this.$translate('click_to_remove')
        },
        selectedLabel() {
            return this.$translate('selected')
        },

    },

    watch: {
        selectedAssets: {
            handler: function (val) {
                console.log('val', val)
                this.$emit(
                    'input',
                    val.map(x => x.value)
                )
            },
        },
        'is_customer_or_company_asset': function (val, oldVal) {
            console.log('asset_type is_customer_or_company_asset', val, oldVal)
            this.selectedAssets = []
            if (val == 2 && this.company && this.company.customer_id){
                this.cust_id = this.company.customer_id;
            } else {
                this.cust_id = this.customer_id;
            }
            // this.customerAssets = []
            this.doSearch()
        },
    },

    async created() {
        await Promise.all([this.$store.dispatch("company/fetch")]);

        EventBus.$on("set-is_customer_or_company_asset", (is_customer_or_company_asset) => {
            console.log("is_customer_or_company_asset", is_customer_or_company_asset);
            this.is_customer_or_company_asset = is_customer_or_company_asset;  
            if(is_customer_or_company_asset == 2 && this.company && this.company.customer_id) {
                this.cust_id = this.company.customer_id;
            }          
        });
    },

    async mounted() {
        await this.doSearch()
        // const { value, customerAssets } = this
        // console.log('this.customerAssets', customerAssets, value)
        // const assetValue = value.map(id =>
        //     customerAssets.find(asset => asset.id == id)
        // )
        // this.selectedAssets = this.parseAssets(assetValue)
    },

    methods: {
        parseAssets(assets) {
            return assets && assets.map(x => ({
                value: x?.id,
                text: `${x?.name}${x?.serial_no ? '-' + x?.serial_no : ''}`,
            }))
        },
        async doSearch() {
            try {
                this.loading = true;
                const $this = this;

                const query = "";
                if(this.is_customer_or_company_asset == 2 && this.company && this.company.customer_id) {
                    this.cust_id = this.company.customer_id;
                    await this.$nextTick()
                }
                // // allow to see company asset as well with customer asset list to select with item detail.
                let customer_id = this.cust_id;

                const filters = { customer_id, allow_company_asset: true, master_items: this.master_item_id };

                let page = 0;
                this.customerAssets = []

                await this.$store.dispatch("assets/fetch", {
                    query,
                    page,
                    filters,
                });
                await this.$nextTick()

                const { assets } = this;
                for (const asset of assets) {
                const { id, name, serial_no, customer_id: asset_customer_id } = asset;
                // if (asset_customer_id != customer_id) continue;
                if (!this.customerAssets.some((x) => x.id == id))
                    this.customerAssets.push({ id, name, serial_no, customer_id: asset_customer_id });
                }
                await this.$nextTick()

                let { value, customerAssets, company } = this
                const assetValue = value.map(id =>
                    customerAssets.find(asset => asset.id == id)
                )
                this.selectedAssets = this.parseAssets(assetValue)
            } catch(err) {
                console.log('error while fethcing assets: ', err)
            } finally {
                this.loading = false;
            }
        }
    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.custom-control.custom-control-inline.custom-radio {
    display: inline;
    margin-right: 15px;
}
</style>
